/**
 * ProtectedRoute — auth gate for the estimator.
 *
 * Staff-only sales tool. Fails closed: no session → /login; any session
 * whose JWT role claim is not a staff role (including a missing claim) →
 * /unauthorized, where the session is signed out.
 */
import { Navigate, Outlet } from 'react-router-dom';
import { isStaffRole } from '@pazportal/types';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute() {
  const { session, loading, role } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface" role="status" aria-live="polite">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin" aria-hidden="true" />
          <span className="text-sm font-semibold text-primary">Checking your session</span>
        </div>
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;
  if (!isStaffRole(role)) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
